import { Box, SxProps } from "@mui/material"
interface Props {
    sx?: SxProps,
    size?: number,
}

export const ArrowComponent = ({
    sx,
    size = 40
}: Props) => {

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                ...sx
            }}
        >
            <Box
                sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "3px solid transparent",
                    borderRight: "3px solid transparent",
                    borderBottom: "5px solid black",
                }}
            />
            <Box
                sx={{
                    width: "1px",
                    height: `${size}px`,
                    backgroundColor: "black",
                }}
            />
        </Box>
    )
}